import {
  Component,
  EventEmitter,
  Injector,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Observable, combineLatest, map } from 'rxjs';
import { ComponentBase } from '../../base/base.component';
import { CommonQuestionModel, ResourceQuestion } from '../../models';

type QuestionType = { active: boolean; data: ResourceQuestion };

@Component({
  selector: 'app-questions-resource-list',
  templateUrl: './questions-resource-list.component.html',
  styleUrls: ['./questions-resource-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class QuestionsResourceListComponent extends ComponentBase {
  questions$: Observable<QuestionType[]>;

  @Input() value: ResourceQuestion[];

  @Output() addQuestion = new EventEmitter<ResourceQuestion>();

  resourceName: string;

  @Input() set query(val: { resourceName: string; visitType: string }) {
    if (val) {
      this.questions$ = this._getResource(val);
    }
  }

  trackByFn(index: number, item: QuestionType) {
    return item?.data?._id;
  }

  /**
   *
   */
  constructor(public injector: Injector) {
    super(injector);
  }

  add(question: ResourceQuestion) {
    this.addQuestion.emit(question);
  }

  private _getResource({ resourceName, visitType }) {
    return combineLatest([
      this.questionsService.getResourceData(resourceName, {
        limit: Number.MAX_SAFE_INTEGER,
        sort: 'data.order',
        'data.type__regex':
          `${visitType}`.toLowerCase() === 'programmatic'
            ? 'institutionalProgrammatic'
            : 'institutionalAccreditation',
      }),
      this.questionsStore.questionsStore$,
    ]).pipe(this.mapResourceQuestionsAndUpdateByIsAdded());
  }

  mapResourceQuestionsAndUpdateByIsAdded() {
    return map(
      ([resourceQuestions, commonQuestions]: [
        ResourceQuestion[],
        CommonQuestionModel[]
      ]) => {
        return resourceQuestions.map((faq) => {
          return {
            data: faq,
            active: commonQuestions.every((itm) => itm.questionKey !== faq.key),
          };
        });
      }
    );
  }
}
